import { Field, useFormikContext } from 'formik';
import React from 'react';
import { FormErrorUI, FormLabelUI, InputUI } from '../../Interface';

const ComplaintReportD7 = ({ disabled }) => {
  const { values, errors } = useFormikContext();

  return (
    <div>
      <Field
        type="text"
        name="description"
        as={InputUI}
        className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
        fullWidth
        label={<FormLabelUI text="Leírás" />}
        variant="standard"
        helperText={<FormErrorUI message={errors.description} />}
        disabled={disabled}
        InputLabelProps={{ shrink: values.description && values.description !== '' }}
        multiline
        rows={4}
      />
    </div>
  );
};

export default ComplaintReportD7;
